// Autogenerated file
export const parcelProviderTypesEnum = {
    RussianPost: "RussianPost",
    Cdek: "Cdek",
};
export const parcelProviderTypes = [
    { label: "Почта России", value: "RussianPost" },
    { label: "СДЭК", value: "Cdek" },
];
